import * as Yup from 'yup';
import moment from 'moment';
import { isEmpty, isNil } from 'ramda';
import { URL_REGEXP } from './constants';

const today = moment().format('YYYY-MM-DD HH:mm:ss');
const todayPlusOneHr = moment().add(1, 'hour').format('YYYY-MM-DD HH:mm:ss');

export default {
  submitButton: 'calendar_events:FORM.BUTTONS.CREATE_EVENT',
  submitButtonEdit: 'calendar_events:FORM.BUTTONS.SAVE_CHANGES',
  defaultValues: {
    type: '',
    title: '',
    location: '',
    conference_url: '',
    description: '',
    center: [],
    classroom: [],
    student: [],
    all_day: false,
    start_date: today,
    end_date: todayPlusOneHr,
    start_hour: today,
    end_hour: todayPlusOneHr,
    notify_parents: false,
  },
  fields: [
    {
      type: 'text',
      id: 'title',
      name: 'title',
      label: 'calendar_events:FORM.EVENT_NAME',
      placeholder: 'calendar_events:FORM.ADD_EVENT_NAME',
      limit: 70,
      required: true,
    },
    {
      type: 'text',
      id: 'location',
      name: 'location',
      label: 'calendar_events:LOCATION',
      placeholder: 'calendar_events:FORM.ADD_EVENT_LOCATION',
      limit: 70,
    },
    {
      type: 'text',
      id: 'video_conferencing',
      name: 'video_conferencing',
      label: 'calendar_events:FORM.MEETING_LINK',
      placeholder: 'calendar_events:FORM.ADD_MEETING_LINK',
    },
    {
      type: 'textarea',
      id: 'description',
      name: 'description',
      label: 'calendar_events:FORM.DESCRIPTION',
      placeholder: 'calendar_events:FORM.ADD_EVENT_DESCRIPTION',
      limit: 1000,
    },
    {
      type: 'select',
      id: 'center',
      name: 'center',
      label: 'calendar_events:CENTERS',
      placeholder: 'calendar_events:FORM.CHOOSE_CENTER',
      selectData: {
        checkbox: true,
        multiple: true,
        options: [],
        selectAll: true,
        labelForSelectAll: 'calendar_events:FORM.ALL_CENTERS',
        search: true,
      },
      visibleFor: 'CENTER',
      required: true,
    },
    {
      type: 'select',
      id: 'classroom',
      name: 'classroom',
      label: 'Classrooms',
      placeholder: 'calendar_events:FORM.CHOOSE_CLASSROOM',
      selectData: {
        selectAll: true,
        labelForSelectAll: 'calendar_events:SELECT_ALL',
        checkbox: true,
        multiple: true,
        data: [],
        search: true,
      },
      visibleFor: 'CLASSROOM',
      required: true,
    },
    {
      type: 'select',
      id: 'student',
      name: 'student',
      label: 'calendar_events:STUDENTS',
      placeholder: 'calendar_events:FORM.CHOOSE_STUDENT',
      selectData: {
        checkbox: true,
        multiple: true,
        selectAll: true,
        labelForSelectAll: 'calendar_events:SELECT_ALL',
        data: [],
        groupBy: 'parent',
        search: true,
      },
      visibleFor: 'STUDENT',
      required: true,
    },
    {
      type: 'label',
      id: 'label_to_text',
      name: 'duration_of_event',
      label: 'calendar_events:FORM.DURATION_OF_EVENT',
      required: false,
      labelProps: {},
    },
    {
      type: 'date',
      id: 'start_date',
      name: 'start_date',
      label: '',
      dateProps: {
        icon: false,
        showIndicator: false,
        canSelectYear: true,
      },
      required: true,
    },
    {
      type: 'hour',
      id: 'start_hour',
      name: 'start_hour',
      label: '',
      hourProps: {
        disabled: false,
        icon: false,
        showIndicator: false,
      },
      required: true,
    },
    {
      type: 'label',
      id: 'label_to_text',
      name: 'label_to_text',
      label: 'calendar_events:FORM.TO',
      required: false,
      labelProps: {},
    },
    {
      type: 'date',
      id: 'end_date',
      name: 'end_date',
      label: '',
      dateProps: {
        icon: false,
        showIndicator: false,
        canSelectYear: true,
      },
      required: true,
    },
    {
      type: 'hour',
      id: 'end_hour',
      name: 'end_hour',
      label: '',
      hourProps: {
        disabled: false,
        icon: false,
        showIndicator: false,
      },
      required: true,
    },
    {
      type: 'hidden',
      id: 'all_day',
      name: 'all_day',
      checkboxProps: {
        label: 'calendar_events:FORM.ALL_DAY',
      },
    },
    {
      type: 'recurrence_events',
      id: 'recurrence_events',
      name: 'rrule',
      label: '',
      required: false,
    },
    {
      type: 'switch',
      id: 'notify_parents',
      name: 'notify_parents',
      label: 'calendar_events:FORM.BUTTONS.NOTIFY_PARENTS',
    },
  ],
  validations: Yup.object().shape({
    type: Yup.string().nullable(true),
    conference_url: Yup
      .lazy((value: any) => {
        if (isEmpty(value) || isNil(value)) {
          return Yup.string().nullable();
        }

        return Yup.string().matches(
          URL_REGEXP,
          'calendar_events:ERRORS.INVALID_URL'
        )
      }),
    video_conferencing: Yup
      .lazy((value: any) => {
        if (isEmpty(value) || isNil(value)) {
          return Yup.string().nullable();
        }

        return Yup.string().matches(
          URL_REGEXP,
          'calendar_events:ERRORS.INVALID_URL'
        )
      }),
    title: Yup.string()
      .trim()
      .min(1, 'calendar_events:ERRORS.REQUIRED')
      .max(70, 'calendar_events:ERRORS.MAX_LENGTH')
      .required('campo requerido!')
      .nullable(true),
    location: Yup.string()
      .max(70, 'calendar_events:ERRORS.MAX_LENGTH'),
    description: Yup.string()
      .trim()
      .max(1000, 'calendar_events:ERRORS.MAX_LENGTH'),
    center: Yup.array()
      .when('$type', (type: string, schema: any) => {
        return type === 'center'
          ? schema :
          schema.min(1, 'calendar_events:ERRORS.GUEST_MIN_LENGTH')
      }),
    classroom: Yup.array()
      .when('$type', (type: string, schema: any) => {
        return type === 'classroom'
          ? schema :
          schema.min(1, 'calendar_events:ERRORS.GUEST_MIN_LENGTH')
      }),
    student: Yup.array()
      .when('$type', (type: string, schema: any) => {
        return type === 'student'
          ? schema :
          schema.min(1, 'calendar_events:ERRORS.GUEST_MIN_LENGTH')
      }),
    start_date: Yup.date()
      .when(
        'end_date',
        (end_date: any, schema: any) => (end_date && schema.max(end_date, 'calendar_events:ERRORS.START_DATE_GT_END_DATE')),
      ),
  }, [['start_date', 'end_date'], ['end_date', 'start_date']]),
};
